import { Stack, Typography } from "@mui/material";
import { t } from "i18next";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import Template from "../../../components/Dashboard/Template";
import { useTranslation } from "react-i18next";


const headerData = [
  {
    id: 1,
    label: "workers",
  },
  {
    id: 2,
    label: "totalAppointments",
  },
];

const displayRows = ["top_worker_detail", "totalCompleted"];

function TopWorkers({ tableData, isLoading }) {

  const { t } = useTranslation(["dashboard", "common"])

  return (
    <Template
      primaryHeading={t("topBookedWorkers")}
      secondaryHeading={t("hitList")}
    >
      {tableData?.length > 0 ? (
        <DashboardTable
          showHeader={true}
          headerData={headerData}
          tableData={tableData || []}
          diplayRows={displayRows}
        />
      ) : isLoading === false && tableData?.length === 0 ? (
        <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <Typography variant="h5" fontWeight={600}>
            {t("noDataFound", { ns: "common" })}
          </Typography>
        </Stack>
      ) : null}
    </Template>
  );
}

export default TopWorkers;
